import departmentCommitTypes from './commit-types';
import departmentModel from '../../models/department';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_MY_DEPARTMENT_STATE = {
  department: null,
  isLoading: [],
};

function departmentReducers(state = INITIAL_MY_DEPARTMENT_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case departmentCommitTypes.REPLACE_MY_DEPARTMENT:
      return {
        ...state,
        department: departmentModel(action.department),
      };
    case departmentCommitTypes.RESET_MY_DEPARTMENT_STATE:
      return { ...INITIAL_MY_DEPARTMENT_STATE };
    case departmentCommitTypes.SET_MY_DEPARTMENT:
      return {
        ...state,
        department: departmentModel(action.department),
      };
    case departmentCommitTypes.SET_MY_DEPARTMENT_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    default:
      return state;
  }
}

export default departmentReducers;
